/* generate an id that is unqiue in the session. We use it for generating unique keys
   in react nodes when we don't have any unique id from the database.
*/
let unique_generator = 99999;
export function unique_value(prefix = 'u_') {
    unique_generator = unique_generator + 1;
    return prefix + unique_generator;
}
export function sessionID() {
    // Check if a UUID is already stored in session storage
    let uuid = sessionStorage.getItem('sessionID');
    // If not found, generate a new UUID
    if (!uuid) {
        uuid = crypto.randomUUID();
        sessionStorage.setItem('sessionID', uuid);
    }
    return uuid;
}
